import { Section } from './elemetns';

export { CardsList } from './cardsList';

export const ELEMENTS = {
  Section,
};
